import { MessageCircle } from "lucide-react";
import { DEFAULT_WA, scrollToId } from "../../lib/api";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-ink text-paper border-t border-line-dark">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid md:grid-cols-3 gap-10 items-start">
        <div>
          <img src="/brand/logo-white.png" alt="Contabiltec" className="h-11 w-auto" />
          <p className="mt-4 text-sm text-paper/50 max-w-xs leading-relaxed">
            Assessoria Empresarial. Contabilidade sem complicação, direto com
            especialista.
          </p>
        </div>
        <div className="flex flex-col gap-3">
          {[
            { id: "servicos", label: "Serviços" },
            { id: "ofertas", label: "Ofertas" },
            { id: "sobre", label: "Sobre" },
            { id: "contato", label: "Contato" },
          ].map((l) => (
            <button
              key={l.id}
              data-testid={`footer-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="text-left text-sm text-paper/60 hover:text-paper transition-colors w-max"
            >
              {l.label}
            </button>
          ))}
        </div>
        <div>
          <a
            data-testid="footer-whatsapp-cta"
            href={DEFAULT_WA}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 bg-crimson text-paper font-semibold px-6 py-3 rounded-full hover:bg-crimson-bright transition-colors"
          >
            <MessageCircle size={17} />
            WhatsApp
          </a>
          <p className="mt-6 text-xs text-paper/35">
            © {new Date().getFullYear()} Contabiltec Assessoria Empresarial ·
            Manaus/AM ·{" "}
            <a href="/admin" data-testid="footer-admin-link" className="underline hover:text-paper/70">
              Admin
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
